import { processQRCode, ensureTokenAndQRCode, isIOSAndSafari, isUserHasScan, updateStorage } from './vtoUtils.js';

import {
  getCustomerScan,
  getCustomerScanBySKU,
  getCustomerGuestId,
  verifyGuestScan,
  getGuestScan
} from './proxyApp.js';

export const productPageScanInit = (vtoPopupInit) => {
  let isEventsSet = false;
  let _currentScan = null;
  let _currentHasScan = null;
  let scanBySku = null;

  const classes = {
    tryOn: ".product__try-on",
    tryOnRight: ".product-form__virtual-try-on",
    mobileThumbnails: ".thumbnails-container-mobile.below-mobile .product__media-item"
  }

  const getSKU = () => {
    let sku;

    const elem = document.querySelector("#ProductVariantPerColor");

    const urlParams = new URLSearchParams(window.location.search);
    sku = urlParams.get('sku');
    const variant = +urlParams.get('variant');

    if(!elem) return sku;

    const variants = JSON.parse(elem.innerHTML);

    if(!sku && variants){
      if(!variant){
        let variantActive = variants["variants"].find(x => x.is_available_in_web_stock);

        if(variantActive) sku = variantActive.sku;
      }else{
        let variantActive = variants["variants"].find(x => x.id === variant);

        if(variantActive) sku = variantActive.sku;
      }
    }

    return sku;
  }

  const hideScanContainer = () => {
    const containers = document.querySelectorAll(".try-on-container");
    const productMedia = document.querySelectorAll(".product__media");

    productMedia.forEach(media => {
      media.classList.remove("product__media--active");
    })

    containers.forEach(container => {
      container.classList.remove("try-on-container--active");
    })
  }

  const togglePersonalScanDisplay = (toggleState = true) => {
    if(!_currentScan) return;

    let { route } = _currentScan;

    if(!route) return;

    const containers = document.querySelectorAll(".try-on-container");
    const productMedia = document.querySelectorAll(".product__media");

    if(toggleState){
      productMedia.forEach(media => {
        media.classList.toggle("product__media--active");
      })
    }

    containers.forEach(container => {
      if(toggleState) container.classList.toggle("try-on-container--active");
      container.querySelector(".try-on-container__wrapper").innerHTML = `
      <iframe
        frameborder="0"
        src="https://widget-demo.topology-engineering.com/v1/${route}?&slideFull=true&hint=false"
        id="topology-widget-iframe-2120101510"
        class="personal-scan"
      ></iframe>`;
    })
  }

  const noFitMessageToggle = (isNoFit) => {
    const noFitMessages = document.querySelectorAll(".no-fit-message");
    if(noFitMessages.length) noFitMessages.forEach(message => isNoFit ? message.classList.add("no-fit-message--active") : message.classList.remove("no-fit-message--active"));
  }

  const setEvents = () => {
    const handlers = [
      {
        container: classes.mobileThumbnails,
        listener: hideScanContainer
      }
    ]

    if(_currentHasScan){
      [classes.tryOn, classes.tryOnRight].forEach(container => {
        handlers.push({
          container,
          listener: () => {
            togglePersonalScanDisplay()
            noFitMessageToggle(false)
          }
        });
      });
    } else {
      [classes.tryOn, classes.tryOnRight].forEach(container => {
        handlers.push({
          container,
          listener: () => {
            noFitMessageToggle(true)
          }
        });
      });
    }

    document.addEventListener("click", (e) => {
      const { target } = e;

      handlers.forEach(({ container, listener }) => {
        if(target.classList.contains(container) || target.closest(container)) listener(e);
      });
    })
  }

  const toggleButtons = (show) => {
    const buttons = document.querySelectorAll(".product__try-on");

    buttons.forEach(button => show ? button.classList.add("product__try-on--active") : button.classList.remove("product__try-on--active"));
  }

  const getGuestObject = (guestScanKey) => {
    // Retrieve and parse guest_scan from session storage
    let guestScan = JSON.parse(localStorage.getItem(guestScanKey));

    // Return the ID if it already exists
    if (guestScan) {
        return guestScan;
    }
  }

  function removeFromLocalStorage(key) {
    if (localStorage.getItem(key)) {
        localStorage.removeItem(key);
        console.log(`Item with key '${key}' has been removed from local storage.`);
    }
}

  async function ensureGuestScan() {
    const guestScanKey = 'guest_scan'; // Key for session storage
    const now = new Date(); // Current date and time
    const { id, expiration } = getGuestObject(guestScanKey) || {};
    
    if (id && expiration && new Date(expiration) > now) return id;

    try {
        // Fetch guestScanId using the proxy API
        const { guestScanId, expiration } = await getCustomerGuestId();

        const guestScan = updateStorage(guestScanKey, { id: guestScanId, has_scan: false, expiration });
        
        return guestScan?.id;
    } catch (error) {
        return null;
    }
}

const init = async () => {
  const customerId = window['customerInfo']['id'];
  const guestScanKey = 'guest_scan'; // Key for session storage
  const userScanKey = 'user_scan';
  let currentGuestId = getGuestObject(guestScanKey)?.id;

  const handleIOSAndSafari = () => {
    if (isIOSAndSafari()) {
      const btnContainer = document.querySelector(".vto-flyout-popup__content");
      if (btnContainer) btnContainer.classList.add("show-btn");
    }
  };

  // id = { logged_in_customer_id: loggedInCustomerId } or { guest_id: guestId }
  async function showTryOn(id) {
    const sku = getSKU();

    if(!sku) return;
    
    scanBySku = await getCustomerScanBySKU({sku, ...id});

    
    const hasRoute = !!scanBySku && scanBySku.route;

    if(hasRoute){
      _currentScan = scanBySku;
      _currentHasScan = hasRoute;
    } else {
      _currentScan = undefined;
      _currentHasScan = undefined;
    }
    toggleButtons(true);
    if (isUserHasScan()) {
      vtoPopupInit.onVtoFlyOutClose();
      if(!isEventsSet){
        setEvents();
      }
      isEventsSet = true;
      noFitMessageToggle(!hasRoute);
    } 
  }

  const onGuestScanUpdate = async () => {
    const inProgressMessages = document.querySelectorAll("[data-scan-in-progress]");
    const haveTakenScanText = document.querySelector("[data-have-taken-scan-text]");
    const now = new Date(); // Current date and time
    try {
      const { guestId, status, expiration } = await verifyGuestScan(currentGuestId);
      if (currentGuestId !== guestId) {
        updateStorage (guestScanKey, { id: guestId, expiration })
        currentGuestId = guestId;
      }

      if (status == "COMPLETED" && new Date(expiration) > now) {
        updateStorage (guestScanKey, { has_scan: true, expiration })
        await showTryOn({ guest_id: currentGuestId });
        if (inProgressMessages.length) inProgressMessages.forEach(inProgressMessage => inProgressMessage.classList.add("hidden"));
        haveTakenScanText?.classList.remove("hidden");
        return false;
      } else if (status == "INPROGRESS" && new Date(expiration) > now) {
        if (inProgressMessages.length) inProgressMessages.forEach(inProgressMessage => inProgressMessage.classList.remove("hidden"));
        haveTakenScanText?.classList.add("hidden");
        updateStorage (guestScanKey, { has_scan: false, expiration })
        return false;
      } else if (new Date(expiration) < now) {
        removeFromLocalStorage(guestScanKey);
        await init()
      } else {
        if (inProgressMessages.length) inProgressMessages.forEach(inProgressMessage => inProgressMessage.classList.add("hidden"));
        updateStorage (guestScanKey, { has_scan: false, expiration })
        haveTakenScanText?.classList.remove("hidden");
        return true;
      }
    }
    catch (error) {
      console.error('Error occurred while verifying the scan:', error);
      return true;
    }
  }

  const onUserScanUpdate = async () => {
    const inProgressMessages = document.querySelectorAll("[data-scan-in-progress]");
    const haveTakenScanText = document.querySelector("[data-have-taken-scan-text]");
    try {
      const { status } =  await getCustomerScan(customerId);

      if (status == "COMPLETED") {
        if (inProgressMessages.length) inProgressMessages.forEach(inProgressMessage => inProgressMessage.classList.add("hidden"));
        updateStorage (userScanKey, { has_scan: true });
        await showTryOn({ logged_in_customer_id: customerId });
        haveTakenScanText?.classList.remove("hidden");
        return false;
      } else if (status == "INPROGRESS") {
        if (inProgressMessages.length) inProgressMessages.forEach(inProgressMessage => inProgressMessage.classList.remove("hidden"));
        updateStorage (userScanKey, { has_scan: false })
        haveTakenScanText?.classList.add("hidden");
        return false;
      } else {
        if (inProgressMessages.length) inProgressMessages.forEach(inProgressMessage => inProgressMessage.classList.add("hidden"));
        updateStorage (userScanKey, { has_scan: false })
        haveTakenScanText?.classList.remove("hidden");
        return true;
      }
    }
    catch (error) {
      console.error('Error occurred while verifying the scan:', error);
      return true;
    }
  }

  const toggleNoScanMessage = (show, wrapper) => {
    const noScanMessage = wrapper.querySelector("[data-no-scan-message]");
    if (noScanMessage) {
      if (show) {
        noScanMessage.classList.remove("hidden");
      } else {
        noScanMessage.classList.add("hidden");
      }
    }
  }

  async function refreshBtnInit () {
    const scanRefreshButtons = document.querySelectorAll('[data-on-scan-refresh]');
    if(scanRefreshButtons.length){
      if (!customerId) {
        scanRefreshButtons.forEach(btn => btn.addEventListener('click', async () => {
          const isNoScanMessageShow = await onGuestScanUpdate();
          const sectionWrapper = btn.closest("section");
          if (!isNoScanMessageShow) {
            const { route, status } = await getGuestScan(currentGuestId);
            const guestScanWrapper = sectionWrapper.querySelector("[data-scan-image-wrapper]");
            const noScanImage = sectionWrapper.querySelector("[data-no-scan-image]");
            const successMessage = sectionWrapper.querySelector(".my-scan__success-message");
            const qrCodeWrapper = sectionWrapper.querySelector(".my-scan__code-wrapper");
            if (status == "COMPLETED" && guestScanWrapper && route && !successMessage) {
              guestScanWrapper.innerHTML = `
              <iframe
                frameborder="0"
                src="https://widget-demo.topology-engineering.com/v1/${route}?hint=false&slideFull=true"
                id="topology-widget-iframe-2120101510"
                class="personal-scan"
              ></iframe>`;
              guestScanWrapper.classList.remove("hidden");
              noScanImage?.classList.add("hidden");
            } else if (status == "COMPLETED" && successMessage) {
              successMessage.classList.remove("hidden");
              qrCodeWrapper?.classList.add("hidden");
            }
          }
          toggleNoScanMessage(isNoScanMessageShow, sectionWrapper);
        }
      ));
      } else {
        scanRefreshButtons.forEach(btn => btn.addEventListener('click', async () => {
          const isNoScanMessageShow = await onUserScanUpdate();
          const sectionWrapper = btn.closest("section");
          toggleNoScanMessage(isNoScanMessageShow, sectionWrapper);
        }));
      }
    }
  }

  const isProductPage = document.querySelector("[data-section-type='product']");
  const isNoScanPage = document.querySelector(".no-scan-page-wrapper");

  if (!customerId) {
    removeFromLocalStorage(userScanKey);
  } else {
    removeFromLocalStorage(guestScanKey);
  }
  
  if(!isProductPage && !isNoScanPage) return;
  
  if (!customerId) {
    await onGuestScanUpdate();
    const guestId = await ensureGuestScan();
    currentGuestId = guestId;
    
    if (guestId) {
      try {
        await processQRCode('externalGuestId', guestId);
        handleIOSAndSafari();
        if (isProductPage) {
          await showTryOn({ guest_id: guestId });
        }
      } catch (e) {
        console.error(e)
      }
    }
  } else {
    try {
      await onUserScanUpdate();
      const { token, qr_code } = await ensureTokenAndQRCode();
      if (token && qr_code) {
        await processQRCode('token', token, qr_code);
        handleIOSAndSafari();
      }
      await showTryOn({ logged_in_customer_id: customerId });
    } catch (e) {
      console.error(e)
    }
  }
  await refreshBtnInit();
}

  init();

  return {
    init,
    togglePersonalScanDisplay,
    hideScanContainer,
    scanBySku
  }
}